/* global JSX */
import * as React from "react";
import Datetime from "react-datetime";
import * as moment from "moment";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskTypeCol, TaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { TaskDataRowDataType, EnumHelper } from "ui/Scripts/source/models/enums";
import { CheckBox } from "ui/Scripts/source/components/framework/checkbox";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITaskTypePage } from "ui/Scripts/source/models/task/taskTypePage";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

//TaskDynamicFormLabel
//***************************************************************
export interface ITaskDynamicFormLabelProp {
    taskTypeCol: ITaskTypeCol;
    buttons?: React.ReactNode
}

export class TaskDynamicFormLabel extends React.Component<ITaskDynamicFormLabelProp, {}> {
    render() {
        const props = this.props;
        const col = props.taskTypeCol;
        return (
            !Base.isNullOrEmpty(col.title)
                ? <div style={{ display: "flex" }}><label className="control-label">{col.title}</label>{props.buttons}</div>
                : null
        );
    }
}

//TaskDynamicFormString
//***************************************************************
export interface ITaskDynamicFormStringProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormString extends React.Component<ITaskDynamicFormStringProp, {}> {
    handleChange = (event) => {
        const target = event.target;
        const valueStr: string = target.value;
        const newValue = new TaskDataRowCol(this.props.taskDataRowCol);
        newValue.valueStr = valueStr;
        this.props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, strValue, newValue.valueNbr);
        this.props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        const options = !Base.isNullOrUndefined(typeCol.options) && typeCol.options.length > 0
            ? typeCol.options.map(i => IdTitle.createIdTitle(i, i))
            : (!Base.isNullOrUndefined(typeCol.idOptions) && typeCol.idOptions.length > 0
                ? typeCol.idOptions
                : null);
        const createSelectInput = !Base.isNullOrUndefined(options);
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {!Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div className={typeCol.maxLength > 499 ? "preWrap" : ""}>{dataCol.valueStr}</div>
                }
                {!props.isReadOnly && !createSelectInput && typeCol.maxLength > 499 &&
                    <textarea
                        className="form-control"
                        name={typeCol.field}
                        title={typeCol.title}
                        required={typeCol.required}
                        readOnly={typeCol.readOnly}
                        value={dataCol.valueStr}
                        maxLength={typeCol.maxLength > 0 ? typeCol.maxLength : null}
                        placeholder={typeCol.placeholder ? typeCol.placeholder : null}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                    />
                }
                {!props.isReadOnly && !createSelectInput && !(typeCol.maxLength > 499) &&
                    <input
                        className="form-control"
                        name={typeCol.field}
                        title={typeCol.title}
                        required={typeCol.required}
                        readOnly={typeCol.readOnly}
                        value={dataCol.valueStr}
                        maxLength={typeCol.maxLength > 0 ? typeCol.maxLength : null}
                        placeholder={typeCol.placeholder ? typeCol.placeholder : null}
                        autoComplete="off"
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                    />
                }
                {!props.isReadOnly && createSelectInput &&
                    <select
                        className="form-control"
                        name={typeCol.field}
                        title={typeCol.title}
                        required={typeCol.required}
                        disabled={typeCol.readOnly}
                        value={dataCol.valueStr}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                    >
                        {!Base.isNullOrEmpty(typeCol.placeholder) &&
                            <option key="ph" value="">{typeCol.placeholder}</option>
                        }
                        {options.map((option) =>
                            <option key={option.id} value={option.id}>{option.title}</option>
                        )}
                    </select>
                }
            </div>
        );
    }
}

//TaskDynamicFormNumber
//***************************************************************
export interface ITaskDynamicFormNumberProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormNumber extends React.Component<ITaskDynamicFormNumberProp, {}> {
    handleChange = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = Base.filterDecimalStr(target.value, typeCol.minimum, typeCol.maximum, typeCol.decimals);
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueStr = strValue;
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToNumber(strValue, typeCol.minimum, typeCol.maximum) : 0;
        props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToNumber(strValue, typeCol.minimum, typeCol.maximum) : 0;
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {!Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div>{dataCol.valueStr}</div>
                }
                {!props.isReadOnly &&
                    <input className="form-control" name={typeCol.field} title={typeCol.title} required={typeCol.required} readOnly={typeCol.readOnly} value={dataCol.valueStr} maxLength={typeCol.maxLength > 0 ? typeCol.maxLength : null} placeholder={typeCol.placeholder ? typeCol.placeholder : null} autoComplete="off" onChange={this.handleChange} onBlur={this.handleBlur} />
                }
            </div>
        );
    }
}

//TaskDynamicFormInteger
//***************************************************************
export interface ITaskDynamicFormIntegerProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormInteger extends React.Component<ITaskDynamicFormIntegerProp, {}> {
    handleChange = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = Base.filterIntegerStr(target.value, typeCol.minimum, typeCol.maximum);
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueStr = strValue;
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToInteger(strValue, typeCol.minimum, typeCol.maximum) : 0;
        props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const strValue: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(strValue)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            this.props.onChange(newValue);
            return;
        }
        newValue.valueNbr = !Base.isNullOrEmpty(strValue) ? Base.strToInteger(strValue, typeCol.minimum, typeCol.maximum) : 0;
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {!Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div>{dataCol.valueStr}</div>
                }
                {!props.isReadOnly &&
                    <input className="form-control" name={typeCol.field} title={typeCol.title} required={typeCol.required} readOnly={typeCol.readOnly} value={dataCol.valueStr} maxLength={typeCol.maxLength > 0 ? typeCol.maxLength : null} placeholder={typeCol.placeholder ? typeCol.placeholder : null} autoComplete="off" onChange={this.handleChange} onBlur={this.handleBlur} />
                }
            </div>
        );
    }
}

//TaskDynamicFormDate
//***************************************************************
export interface ITaskDynamicFormDateProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormDate extends React.Component<ITaskDynamicFormDateProp, {}> {
    handleChange = (value: moment.Moment | string) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                newValue.valueStr = "";
                newValue.valueNbr = typeCol.required ? 0 : null;
            } else {
                newValue.valueStr = value;
                newValue.valueNbr = value.toUtcDate().getTime();
            }
        } else {
            newValue.valueStr = Base.utcTimeToDateStr(value);
            newValue.valueNbr = newValue.valueStr.toUtcDate().getTime();
        }
        props.onChange(newValue);
    };

    handleBlur = (value: moment.Moment | string) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                newValue.valueNbr = typeCol.required ? 0 : null;
            } else {
                newValue.valueNbr = value.toUtcDate().getTime();
            }
        } else {
            newValue.valueNbr = Base.utcTimeToDateStr(value).toUtcDate().getTime();
        }
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {!Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div>{dataCol.valueStr}</div>
                }
                {!props.isReadOnly &&
                    <Datetime
                        locale={appConfig.culture}
                        className={"roWhite"}
                        value={dataCol.valueStr}
                        dateFormat={"D.M.YYYY"}
                        timeFormat={false}
                        closeOnSelect={true}
                        inputProps={{ maxLength: 10, readOnly: true, disabled: typeCol.readOnly }}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                    />
                }
            </div>
        );
    }
}

//TaskDynamicFormTime
//***************************************************************
export interface ITaskDynamicFormTimeProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormTime extends React.Component<ITaskDynamicFormTimeProp, {}> {
    handleChange = (value: moment.Moment | string) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                newValue.valueStr = "";
                newValue.valueNbr = typeCol.required ? 0 : null;
            } else {
                newValue.valueStr = value;
                newValue.valueNbr = value.toUtcTime().getTime();
            }
        } else {
            newValue.valueStr = Base.timeToTimeStr(value);
            newValue.valueNbr = newValue.valueStr.toUtcTime().getTime();
        }
        props.onChange(newValue);
    };

    handleBlur = (value: moment.Moment | string) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (typeof value === "string") {
            if (Base.isNullOrEmpty(value)) {
                newValue.valueNbr = typeCol.required ? 0 : null;
            } else {
                newValue.valueNbr = value.toUtcTime().getTime();
            }
        } else {
            newValue.valueNbr = Base.timeToTimeStr(value).toUtcTime().getTime();
        }
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {!Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div>{dataCol.valueStr}</div>
                }
                {!props.isReadOnly &&
                    <Datetime
                        locale={appConfig.culture}
                        className={"roWhite tPicker"}
                        value={dataCol.valueStr}
                        dateFormat={false}
                        timeFormat={"H:mm"}
                        closeOnSelect={true}
                        input={true}
                        inputProps={{ maxLength: 10, readOnly: true, disabled: typeCol.readOnly }}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                    />
                }
            </div>
        );
    }
}

//TaskDynamicFormTimeSpan
//***************************************************************
export interface ITaskDynamicFormTimeSpanProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormTimeSpan extends React.Component<ITaskDynamicFormTimeSpanProp, {}> {
    handleChange = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const value: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(value)) {
            newValue.valueStr = "";
            newValue.valueNbr = null;
            return;
        } else {
            newValue.valueStr = value;
            newValue.valueNbr = value.toTimeSpan();
        }
        props.onChange(newValue);
    };

    handleBlur = (event) => {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const target = event.target;
        const value: string = target.value;
        const newValue = new TaskDataRowCol(props.taskDataRowCol);
        if (!typeCol.required && Base.isNullOrEmpty(value)) {
            newValue.valueNbr = null;
        } else {
            newValue.valueNbr = value.toTimeSpan();
        }
        newValue.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, newValue.valueStr, newValue.valueNbr);
        props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {!Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div>{dataCol.valueStr}</div>
                }
                {!props.isReadOnly &&
                    <input className="form-control" name={typeCol.field} title={typeCol.title} required={typeCol.required} readOnly={typeCol.readOnly} value={dataCol.valueStr} maxLength={10} placeholder={typeCol.placeholder ? typeCol.placeholder : null} autoComplete="off" onChange={this.handleChange} onBlur={this.handleBlur} />
                }
            </div>
        );
    }
}

//TaskDynamicFormBoolean
//***************************************************************
export interface ITaskDynamicFormBooleanProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormBoolean extends React.Component<ITaskDynamicFormBooleanProp, {}> {
    handleCheckboxClickBoolean = (checked: boolean) => {
        const newValue = new TaskDataRowCol(this.props.taskDataRowCol);
        newValue.valueNbr = checked ? 1 : 0;
        newValue.valueStr = checked ? "1" : "0";
        this.props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <div className={"form-group" + (typeCol.required ? " required" : "")}>
                {props.isReadOnly && !Base.isNullOrEmpty(typeCol.title) &&
                    <TaskDynamicFormLabel
                        taskTypeCol={typeCol}
                    />
                }
                {props.isReadOnly &&
                    <div>{Base.strToBool(dataCol.valueStr) ? "X" : "_"}</div>
                }
                {!props.isReadOnly &&
                    <CheckBox
                        title={typeCol.title}
                        name={typeCol.field}
                        disabled={typeCol.readOnly}
                        checked={Base.strToBool(dataCol.valueStr)}
                        onClickBoolean={this.handleCheckboxClickBoolean}
                    />
                }
            </div>
        );
    }
}

//TaskDynamicFormLineBreak
//***************************************************************
export interface ITaskDynamicFormLineBreakProp {
    taskTypeCol: ITaskTypeCol;
}

export class TaskDynamicFormLineBreak extends React.Component<ITaskDynamicFormLineBreakProp, {}> {
    render() {
        return (
            <div className="lineBreak"></div>
        );
    }
}

//TaskDynamicFormSignature
//***************************************************************
export interface ITaskDynamicFormSignatureProp {
    isReadOnly: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export const TaskDynamicFormSignature = (props: ITaskDynamicFormSignatureProp) => {
    const container = useRef<HTMLDivElement>();
    const canvas = useRef<SignatureCanvas>();
    const [size, setSize] = useState<DOMRect>();

    const typeCol = props.taskTypeCol;
    const dataCol = props.taskDataRowCol;
    
    const resizeContainer = () => {
        const containerRect = container.current.getBoundingClientRect();
        setSize(containerRect);
    };

    const resizeCanvas = () => {
        if (!container.current) return;
        const containerRect = container.current.getBoundingClientRect();
        setSize(containerRect);
        if (!canvas.current) return;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const aCanvas = canvas.current.getCanvas();
        aCanvas.width = containerRect.width * ratio;
        aCanvas.height = containerRect.height * ratio;
        aCanvas.getContext("2d").scale(ratio, ratio);
        canvas.current.clear(); // otherwise isEmpty() might return incorrect value
        if (!dataCol?.valueStr) return;
        canvas.current.fromDataURL(`data:image/png;base64,${dataCol?.valueStr}`);
    };

    useEffect(() => {
        window.addEventListener("resize", resizeCanvas);
        return () => window.removeEventListener("resize", resizeCanvas);
    }, []);
    
    useEffect(() => {
        if (!container.current) return;
        resizeContainer();
    }, [container.current, props.taskTypeCol?.class]);

    useEffect(() => {
        if (!container.current || !canvas.current) return;
        resizeCanvas();
    }, [container.current, canvas.current]);
    
    useEffect(() => {
        if (!canvas.current) return;
        if (!dataCol?.valueStr) return;
        canvas.current.fromDataURL(`data:image/png;base64,${dataCol?.valueStr}`);
    }, [props.taskDataRowCol?.valueStr, canvas.current]);
    
    const handleChange = (e: any) => {
        if (!canvas.current) return;
        const newValue = new TaskDataRowCol(dataCol);
        const image = canvas.current.toDataURL(); //PNG
        if (!image) return;
        const index = image.indexOf(",");
        if (index < 0) return;
        newValue.valueStr = image.substring(index + 1);
        props.onChange(newValue);
    };

    const handleClear = () => {
        if (!canvas.current) return;
        canvas.current.clear();
        const newValue = new TaskDataRowCol(dataCol);
        newValue.valueStr = "";
        props.onChange(newValue);
    };
    
    const isReadOnly = props.isReadOnly;

    const clearButton = isReadOnly
        ? undefined
        : <div className="signatureClear" style={{ marginLeft: "auto" }}>
            <ToolButton
                tooltip={Translations.Remove}
                classes="round mono delete"
                onClick={handleClear}
            />
        </div>;

    return (
        <div className={"form-group" + (typeCol.required && !isReadOnly ? " required" : "")}>
            {!Base.isNullOrEmpty(typeCol.title) &&
                <TaskDynamicFormLabel
                    taskTypeCol={typeCol}
                    buttons={clearButton}
                />
            }
            {!typeCol.title && !isReadOnly &&
                <div style={{ display: "flex" }}>
                    {clearButton}
                </div>
            }
            <div ref={container} className="signature" style={{ pointerEvents: isReadOnly ? "none" : undefined, cursor: isReadOnly ? "not-allowed" : undefined }}>
                {(isReadOnly || !size
                    ? <img
                        style={{
                            height: "100%",
                            objectFit: "contain"
                        }}
                        src={dataCol?.valueStr ? `data:image/png;base64,${dataCol?.valueStr}` : ""}
                    />
                    : <SignatureCanvas
                        ref={canvas}
                        canvasProps={{ width: size.width + "px", height: size.height + "px", style: { border: "1px solid rgba(0, 0, 0, 0.23)", borderRadius: "4px", width: size.width + "px", height: size.height + "px" } }}
                        dotSize={2}
                        onEnd={(e) => {
                            handleChange(e);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

//TaskDynamicFormCol
//***************************************************************
export interface ITaskDynamicFormColProp {
    isReadOnly: boolean;
    isEdit?: boolean;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormCol extends React.Component<ITaskDynamicFormColProp, {}> {
    render() {
        const props = this.props;
        const col = props.taskTypeCol;
        let element = null;
        if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Label)) {
            element =
                <TaskDynamicFormLabel
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.String)) {
            element =
                <TaskDynamicFormString
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Number)) {
            element =
                <TaskDynamicFormNumber
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Integer)) {
            element =
                <TaskDynamicFormInteger
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Date)) {
            element =
                <TaskDynamicFormDate
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Time)) {
            element =
                <TaskDynamicFormTime
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.TimeSpan)) {
            element =
                <TaskDynamicFormTimeSpan
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Boolean)) {
            element =
                <TaskDynamicFormBoolean
                    isReadOnly={props.isReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Signature)) {
            element =
                <TaskDynamicFormSignature
                    isReadOnly={props.isReadOnly || !!props.isEdit}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.LineBreak)) {
            element =
                <TaskDynamicFormLineBreak
                    taskTypeCol={col}
                />;
        }
        return (
            <div className={"col " + (!Base.isNullOrEmpty(col.class) ? col.class : "")}>
                {element}
            </div>
        );
    }
}

//Expression Functions
//***************************************************************
const globalPointer = window as any;

globalPointer.minutesToDateStr = (minutes: number) => Base.minutesToDateStr(minutes);

globalPointer.utcDateAndTimeDiffInMinutes = (date1: Date, time1: Date, date2: Date, time2: Date) => Base.utcDateAndTimeDiffInMinutes(date1, time1, date2, time2);

globalPointer.utcDateAndTimeDiffInTimeSpan = (date1: Date, time1: Date, date2: Date, time2: Date) => Base.utcDateAndTimeDiffInTimeSpan(date1, time1, date2, time2);

//TaskDynamicForm
//***************************************************************
export interface ITaskDynamicFormPage {
    title: string;
    headerClass: string;
    formHeight: number;
    showAttachments: boolean;
    attachmentsHeight: number;
    enableDialogButtons: boolean;
    taskTypeCols: ITaskTypeCol[];
}

export interface ITaskDynamicFormPages {
    pages: ITaskDynamicFormPage[];
    hash: string;
}

export interface ITaskDynamicFormProp {
    classes?: string;
    isReadOnly: boolean;
    isEdit?: boolean;
    taskTypePages: ITaskTypePage[];
    taskTypeCols: ITaskTypeCol[];
    taskDataRowCols: ITaskDataRowCol[];
    attachmentsElement: JSX.Element;
    onEnableDialogButtons?: (enable: boolean) => void;
    onRefreshCols: (taskDataRowCols: ITaskDataRowCol[]) => void;
}

export interface ITaskDynamicFormState {
    paging: ITaskDynamicFormPages;
    activePage: number;
}

export class TaskDynamicForm extends React.Component<ITaskDynamicFormProp, ITaskDynamicFormState> {
    static getTaskDynamicFormPages = (props: ITaskDynamicFormProp): ITaskDynamicFormPages => {
        const taskTypeCols = props.taskTypeCols.map(i => new TaskTypeCol(i));
        const result: ITaskDynamicFormPages = {
            pages: [],
            hash: TaskDynamicForm.getPropsHash(props.taskTypePages, props.taskTypeCols)
        };
        //No pages
        if (props.taskTypePages.length < 1) {
            result.pages.push({
                title: null,
                headerClass: "",
                formHeight: 0,
                showAttachments: true,
                attachmentsHeight: 0,
                enableDialogButtons: true,
                taskTypeCols
            });
        } else {
            for (const page of props.taskTypePages) {
                result.pages.push({
                    title: page.title,
                    formHeight: page.formHeight,
                    headerClass: page.headerClass,
                    showAttachments: page.showAttachments,
                    attachmentsHeight: page.attachmentsHeight,
                    enableDialogButtons: page.enableDialogButtons,
                    taskTypeCols: page.fields.map(i => taskTypeCols.find(j => j.field === i)).filter(i => !!i)
                });
            }
        }
        return result;
    };
    
    static getPropsHash = (taskTypePages: ITaskTypePage[], taskTypeCols: ITaskTypeCol[]) => {
        return taskTypeCols.map(i => i.field) + "#" + taskTypePages.map(i => i.getHash());
    };

    constructor(props: ITaskDynamicFormProp) {
        super(props);
        this.state = {
            paging: TaskDynamicForm.getTaskDynamicFormPages(props),
            activePage: 0
        };
    }

    handleEnableDialogButtons = (enable: boolean) => {
        const props = this.props;
        if (!props.onEnableDialogButtons) return;
        props.onEnableDialogButtons(enable);
    };

    componentDidMount(): void {
        this.handleEnableDialogButtons(this.state.paging.pages[0].enableDialogButtons);
    }

    //This used, because it runs before render => paging is updated before re-render => no conflict between types and data if type changes
    static getDerivedStateFromProps(props: ITaskDynamicFormProp, state: ITaskDynamicFormState) {
        const hash = TaskDynamicForm.getPropsHash(props.taskTypePages, props.taskTypeCols);
        if (hash === state.paging.hash) return null;
        const paging = TaskDynamicForm.getTaskDynamicFormPages(props);
        return {
            paging,
            activePage: paging.pages.length <= state.activePage ? 0 : state.activePage
        };
    }

    handleValueChange = (dataCol: ITaskDataRowCol) => {
        if (Base.isNullOrUndefined(dataCol)) return;
        const props = this.props;
        const taskDataRowCols = props.taskDataRowCols.slice(0);
        const taskDataRowCol = taskDataRowCols.find(i => i.field === dataCol.field);
        taskDataRowCol.valueStr = dataCol.valueStr;
        taskDataRowCol.valueNbr = dataCol.valueNbr;
        TaskEditTypeItem.evaluateColsExpressions(taskDataRowCols, props.taskTypeCols, (error) => {
            console.log(error);
        });
        props.onRefreshCols(taskDataRowCols);
    };

    handleMoveToPreviousPage = () => {
        const state = this.state;
        const activePage = Math.max(0, state.activePage - 1);
        this.setState({
            activePage
        });
        this.handleEnableDialogButtons(state.paging.pages[activePage].enableDialogButtons);
    };

    handleMoveToNextPage = () => {
        const state = this.state;
        const activePage = Math.min(state.paging.pages.length - 1, state.activePage + 1);
        this.setState({
            activePage
        });
        this.handleEnableDialogButtons(state.paging.pages[activePage].enableDialogButtons);
    };

    render() {
        const props = this.props;
        const state = this.state;
        const taskTypeCols = props.taskTypeCols;
        if (!taskTypeCols) return null;
        const hasMultiplePages = state.paging.pages.length > 1;
        return (
            <div className={"col-12 jsonFormPages" + (hasMultiplePages ? " padBottom" : "") + (props.classes ? " " + props.classes : "")}>
                {state.paging.pages.map((page, index) =>
                    <div key={index} className={"jsonFormPage" + (index === state.activePage ? "" : " d-none")}>
                        {page.title &&
                            <div className={"pageHeader" + (page.headerClass ? " " + page.headerClass : "")}>
                                <label className="control-label pageTitle">{page.title}</label>
                            </div>
                        }
                        <div className="jsonFormData" style={page.formHeight ? { minHeight: page.formHeight.toString(10) + "px" } : null}>
                            <div className="row">
                                {page.taskTypeCols.map((taskTypeCol) =>
                                    <TaskDynamicFormCol
                                        key={taskTypeCol.field}
                                        isReadOnly={props.isReadOnly}
                                        isEdit={props.isEdit}
                                        taskTypeCol={taskTypeCol}
                                        taskDataRowCol={props.taskDataRowCols.find(i => i.field === taskTypeCol.field)}
                                        onChange={this.handleValueChange}
                                    />
                                )}
                            </div>
                        </div>
                        {page.showAttachments && !!props.attachmentsElement &&
                            <div className="jsonFormAttachments" style={page.attachmentsHeight ? { minHeight: page.attachmentsHeight.toString(10) + "px" } : null}>
                                {props.attachmentsElement}
                            </div>
                        }
                        {hasMultiplePages &&
                            <div className="pageFooter">
                                <ToolButton
                                    tooltip={Translations.Previous}
                                    classes={"previous round mono"}
                                    disabled={state.activePage < 1}
                                    onClick={this.handleMoveToPreviousPage}
                                />
                                <ToolButton
                                    tooltip={Translations.Next}
                                    classes={"next round mono"}
                                    disabled={state.activePage >= state.paging.pages.length - 1}
                                    onClick={this.handleMoveToNextPage}
                                />
                            </div>
                        }
                    </div>
                )}
            </div>
        );
    }
}